import { Logger } from "../../../util/log/Logger";
import { ViewUtils } from "../../../util/view/ViewUtils";
import { GameErrorEvent } from "../../Constants";
import { MessageDialog } from "./MessageDialog";
/**
 * RealityCheckNoOptionsDialog.ts
 */
export class RealityCheckNoOptionsDialog extends MessageDialog {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.properties = properties;
    }
    create() {
        super.create();
        this.createTimeField();
        this.updateTime();
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "RealityCheckNoOptionsDialog");
    }
    createTimeField() {
        this.timeField = ViewUtils.createField(this, this.properties.timeFieldProperties);
    }
    updateTime() {
        this.timeField.setText(this.formatTime());
    }
    formatTime() {
        let now = new Date();
        let time = [now.getHours(), now.getMinutes()];
        let suffix = time[0] >= 12 ? "pm" : "am";
        for (let i = 0; i < time.length; i++) {
            if (time[i] < 10) {
                time[i] = "0" + time[i];
            }
        }
        return time.join(":") + " " + suffix;
    }
    handleClose() {
        super.handleClose();
        this.dispatchCore(GameErrorEvent.REALITY_CHECK_CLOSE);
    }
}
//# sourceMappingURL=RealityCheckNoOptionsDialog.js.map